import React, { useEffect, useRef } from 'react';
import { StyledNumberColImage } from './StyledNumberColImage';
import { gsap } from "gsap";

import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const NumberColImage = ({ image }) => {
  const imageBg = useRef(null);

  useEffect(() => {
    gsap.to(imageBg.current, {
      duration: .75,
      ease: "power2.easeInOut",
      scale: 1.1,
      scrollTrigger: {
        trigger: imageBg.current,
        start: "top center"
      }
    })
  }, [])
  return (
    <React.Fragment>
      {
        <StyledNumberColImage>
          <div className="image--column" ref={imageBg} style={{backgroundImage: `url(${image})`}}></div>
        </StyledNumberColImage>
          
      }
    </React.Fragment>
  );
};

export default NumberColImage;
